import { render, staticRenderFns } from "./GraphQL.vue?vue&type=template&id=5a057fa2&scoped=true&"
import script from "./GraphQL.vue?vue&type=script&lang=js&"
export * from "./GraphQL.vue?vue&type=script&lang=js&"
import style0 from "./GraphQL.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GraphQL.vue?vue&type=style&index=1&id=5a057fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a057fa2",
  null
  
)

export default component.exports